import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["body", "closeButton", "chevron"];

  toggle() {
    const isHidden = this.bodyTarget.style.display === "none";
    if (isHidden) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.bodyTarget.style.display = "block";
    this.closeButtonTarget.style.display = "block";
    this.chevronTarget.style.display = "none";
  }

  close() {
    this.bodyTarget.style.display = "none";
    this.closeButtonTarget.style.display = "none";
    this.chevronTarget.style.display = "block";
  }
}
